import React from 'react';
import { LandingPage } from '../features/prichal/LandingPage';

function App() {
  return <LandingPage />;
}

export default App;
